<template>
  <b-modal
    id="admin-cart-expiration-modal"
    :title="trans('cart_expiration')"
    :ok-title="trans('save')"
    :ok-disabled="isExpired"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <p>
      {{ trans('admin_cart_expiration_about') }}
    </p>

    <b-row>
      <b-col class="pr-0">
        <b-form-group :label="trans('date')">
          <datetime
            v-model="date"
            class="form-control"
            :config="dateOptions"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="trans('time')">
          <datetime
            v-model="time"
            class="form-control"
            :config="timeOptions"
          />
        </b-form-group>
        <div v-if="isExpired" class="d-block text-danger text-right pr-2">
          {{ trans('expired') }}
        </div>
        <div v-if="!isExpired" class="d-block text-success text-right pr-2">
          {{ expiredAt.fromNow() }}
        </div>
      </b-col>
    </b-row>

    <p v-if="expiredItemCount > 0" class="text-danger">
      <i class="fa fa-fw fa-exclamation-triangle"></i>
      <em>
        {{ trans('admin_cart_has_expired_items').replace(':count', expiredItemCount) }}
      </em>
    </p>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker'

  export default {
    props: {
      organization: Object,
      invoice: Object,
    },
    components: {
      Datetime,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        date: moment(this.invoice ? this.invoice.expired_at : undefined).format('LL'),
        time: moment(this.invoice ? this.invoice.expired_at : undefined).format('LT'),
        dateOptions: {
          locale: window.lang,
          format: 'LL',
        },
        timeOptions: {
          locale: window.lang,
          format: 'LT',
          stepping: 5,
        },
      }
    },
    computed: {
      expiredAt() {
        return moment(this.date + ' ' + this.time, 'LLL')
      },
      isExpired() {
        return moment().isAfter(this.expiredAt)
      },
      expiredItemCount() {
        return _.reduce(this.invoice.invoice_items, (count, item) => {
          if (item.expired) count += 1
          return count
        }, 0)
      },
    },
    watch: {
      invoice() {
        this.date = moment(this.invoice ? this.invoice.expired_at : undefined).format('LL')
        this.time = moment(this.invoice ? this.invoice.expired_at : undefined).format('LT')
      },
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/cart/expiration/${this.invoice.ucid}`
        axios.patch(url, {
          expired_at: this.expiredAt.toISOString()
        })
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
          this.$bvModal.hide('admin-cart-expiration-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.adminCartExpirationModal = this
    },
  }
</script>